import { ChangeDetectorRef, Component } from '@angular/core';
import { UserNotificationService } from '@ca/core/services';
import { tap } from 'rxjs';

@Component({
    selector: 'ca-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
    isVisible$ = this.userNotificationService.isSpinnerShown$;

    constructor(
        private userNotificationService: UserNotificationService,
        private cd: ChangeDetectorRef,
    ) {
        this.isVisible$
            .pipe(
                tap((): void => {
                    this.cd.detectChanges();
                }),
            )
            .subscribe();
    }
}
